<template>
    <div>
        <template v-if="crud_vendor===true && crud_vendor!==null && getDefault===true">
            <form id="employeeForm" @submit.prevent="addVendorPayment()">
                <div class="page-top mb-1 mb-3 clearfix">
                    <h1 class="float-left"> Add Vendor </h1>
                    <button class="btn btn-primary float-right submit_form" :disabled="beneficiaries.length==0">Next</button>
                    <router-link to="/vendors" class="btn btn-primary float-right mr-1"> Cancel </router-link>
                </div>
                <div class="peopple-managment-main">
                    <ul class="page-status">
                        <li class="page-status-list done">
                            <span class="status-highlighter">1</span>
                            Vendor Details
                        </li>
                        <li class="page-status-list done">
                            <span class="status-highlighter">2</span>
                            Basic Details
                        </li>
                        <li class="page-status-list done">
                            <span class="status-highlighter">3</span>
                            Tax Details
                        </li>
                        <li class="page-status-list active">
                            <span class="status-highlighter">4</span>
                            Payment Details
                        </li>
                    </ul>
                    <div class="people-management-inner-content p-5">
                        <div class="row">
                            <easyPaisaBeneficiaryComponent v-if="$global.user_company_payment_engine == 'EASY_PAISA'" :form="form" :banks="banks" :getEmployeeWalletDetail="getVendorWalletDetail" :addEmployeePaymentDetail="addVendorPaymentDetail" :changeAccountDetail="changeAccountDetail" :editMode="editMode"/>
                            <fincaBeneficiaryComponent v-if="$global.user_company_payment_engine == 'FINCA'" :form="form" :banks="banks" :getEmployeeWalletDetail="getVendorWalletDetail" :addEmployeePaymentDetail="addVendorPaymentDetail" :changeAccountDetail="changeAccountDetail" :editMode="editMode"/>
                            <meezanBeneficiaryComponent v-if="$global.user_company_payment_engine == 'MEEZAN'" :form="form" :banks="banks" :getEmployeeWalletDetail="getVendorWalletDetail" :addEmployeePaymentDetail="addVendorPaymentDetail" :changeAccountDetail="changeAccountDetail" :editMode="editMode"/>
                            <nbpFundsBeneficiaryComponent v-if="$global.user_company_payment_engine == 'NBP_FUND'" :form="form" :banks="banks" :getEmployeeWalletDetail="getVendorWalletDetail" :addEmployeePaymentDetail="addVendorPaymentDetail" :changeAccountDetail="changeAccountDetail" :editMode="editMode"/>
                            <faysalBeneficiaryComponentt v-if="$global.user_company_payment_engine == 'FAYSAL'" :form="form" :banks="banks" :getEmployeeWalletDetail="getVendorWalletDetail" :addEmployeePaymentDetail="addVendorPaymentDetail" :changeAccountDetail="changeAccountDetail" :editMode="editMode"/>
                            <emoneyBeneficiaryComponent v-if="$global.user_company_payment_engine == 'EMONEY'" :form="form" :banks="banks" :getEmployeeWalletDetail="getVendorWalletDetail" :addEmployeePaymentDetail="addVendorPaymentDetail" :changeAccountDetail="changeAccountDetail" :editMode="editMode"/>
                        
                        </div>
                        <div class="fetched-save-detail mt-5 w-100" v-if="beneficiaries.length>0">
                            <table>
                                <thead>
                                    <tr>
                                        <th> Account Title </th>
                                        <th> Account Type </th>
                                        <th> Account Number </th>
                                        <th> Bank Name </th>
                                        <th> Beneficiary Status </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="beneficiary in beneficiaries"
                                            v-bind:key="beneficiary.id"
                                            v-bind:value="beneficiary.id">
                                        <td> {{ beneficiary.account_title }} </td>
                                        <td> {{ beneficiary.account_type }} </td>
                                        <td> {{ beneficiary.account_number }} </td>
                                        <td> {{ beneficiary.bank_name }} </td>
                                        <td> <a href="javascript:void(0);" @click="makeDefault(beneficiary.id)" v-if="beneficiary.is_default == 'NO'">Mark Default</a>
                                                <a v-if="beneficiary.is_default == 'YES'">Default <i class="fa fa-check-circle" style="font-size:18px;color:green"></i></a> </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
            </form>
        </template>
        <template v-else-if="crud_vendor === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="crud_vendor === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    import easyPaisaBeneficiaryComponent from '../partial/easyPaisaBeneficiaryComponent.vue';
    import meezanBeneficiaryComponent from '../partial/meezanBeneficiaryComponent.vue';
    import fincaBeneficiaryComponent from '../partial/fincaBeneficiaryComponent.vue';
    import nbpFundsBeneficiaryComponent from '../partial/nbpFundsBeneficiaryComponent';
    import faysalBeneficiaryComponentt from '../partial/faysalBeneficiaryComponent';
    import emoneyBeneficiaryComponent from '../partial/emoneyBeneficiaryComponent';

    export default {
        components: {
            easyPaisaBeneficiaryComponent,
            meezanBeneficiaryComponent,
            fincaBeneficiaryComponent,
            nbpFundsBeneficiaryComponent,
            faysalBeneficiaryComponentt,
            emoneyBeneficiaryComponent
        },
        data() {
            return {
                editMode : 'NO',
                form: new Form({
                    accountType : '',
                    bank : '',
                    account_number : '',
                    cnic : '',
                    is_default : '',
                    paymentMethod : '',
                    account_detail : false,
                    account_information : {
                        customer_name : '',
                        account_number : '',
                        bank_name : '',
                    },
                    id : this.$route.params.id
                }),
                make_default : new Form({
                    id : '',
                    vid: this.$route.params.id
                }),
                beneficiaries: '',
                mobileNumber: '',
                showNextButton : false,
                banks: null,
                getDefault: null,
                crud_vendor : null,
                basicDetail : 0
            }
        },
        methods: {
            isNumber: function(evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            addVendorPayment(){
                this.$Progress.start();
                axios.post('/api/completeProfileVendor', {
                    id: this.$route.params.id,
                })
                .then(res => {
                    if(res.status == 200){
                        this.showToastBox('success','Vendors profile completed successfully.');
                        this.$router.push('/vendors');
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error',res.data.msg);
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load data');
                });
            },
            makeDefault(id){
                this.$Progress.start();
                this.make_default.id = id;
                this.make_default.post('/api/makeVendorDefaultBeneficiary')
                .then(res => {
                    if (res.status == 200) {
                        this.getDefaultWallet();
                        this.$Progress.finish();
                        this.showToastBox('success','Vendor account set to default successfully');

                    } else {
                        this.$Progress.fail();
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load data');
                });
            },
            changeAccountDetail(){
                this.form.account_detail = false;
            },
            addVendorPaymentDetail() {
                this.$Progress.start();
                this.form.post('/api/addVendorPaymentDetail')
                .then(res => {
                    if(res.status == 200){
                        if(res.data.status == 200){
                            this.$Progress.finish();
                            this.getDefaultWallet();
                            this.showToastBox('success','Vendor beneficiary added successfully');
                            $(".submit_form").prop('disabled',false);
                        }else if(res.data.status == 409){
                            this.$Progress.fail();
                            this.showAlertBox('error',res.data.msg);
                        }
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load data');
                    }

                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load data');
                });
            },
            getVendorWalletDetail(){
                this.$Progress.start();
                if(this.form.paymentMethod == 'BANK' && this.$global.user_company_payment_engine =='MEEZAN'){
                    var accNo = this.form.accountNumber;
                    if(typeof accNo == 'undefined'){
                       this.showAlertBox('error','Account number field is required');
                       return false;
                    }
                    if (accNo.length < 14 || accNo.length > 24) {
                        this.$Progress.fail();
                        this.showAlertBox('error','Account number must be in between 14 to 24 digits');
                        return false;
                    }
                }
                if(this.form.paymentMethod == 'IBFT' && this.$global.user_company_payment_engine =='MEEZAN'){
                    var accNo = this.form.accountNumber;
                    if(typeof accNo == 'undefined'){
                       this.showAlertBox('error','Account number field is required');
                       return false;
                   }
                   if (accNo.length > 24) {
                        this.$Progress.fail();
                        this.showAlertBox('error','Account number must be 24 digits');
                        return false;
                    }
                }

                this.form.post('/api/getVendorWalletDetail')
                .then(res => {
                    if(res.data.code == 200){
                        this.form.account_detail = this.form.accountType;
                        this.form.account_information.customer_name = res.data.data.accountTitle;
                        this.form.account_information.account_number = this.form.accountNumber;
                        if(this.form.accountType == 'IBFT'){
                            this.form.account_information.bank_name = this.form.bank.bank_name;
                            this.form.account_information.bank_code = this.form.bank.bank_code;
                        }
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error',res.data.msg);
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load data');
                });
            },
            getDefaultWallet(){
                var vid = this.$route.params.id;
                this.$Progress.start();
                axios.post('/api/getDefaultWallet', {
                    vid: vid
                })
                .then(res => {
                    if(res.data.status == 200){
                        this.form.wallet_number = res.data.data;
                        this.beneficiaries = res.data.beneficiaries;
                        if(this.beneficiaries.length > 0){
                            this.form.is_default = 'NO';
                        }else{
                            this.form.is_default = 'YES';
                        }
                        this.showWalletDetail = false;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error',res.data.msg);
                    }
                    this.getDefault = true;
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load data');
                });
            },
            getBankList(){
                this.$Progress.start();
                axios.get('/api/ibftBankList')
                .then(res => {
                    if(res.status == 200){
                        if(res.data.bankList != null){
                            this.banks = res.data.bankList;
                        }
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load data');
                    }
                }).then(res => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load data');
                });
            },
        },
        mounted() {
            this.can('crud_vendor').then(result => {
                this.crud_vendor = result.crud_vendor;
            }).then(result => {
                if(this.$global.user_company_payment_engine == 'FINCA'){
                    this.form.paymentMethod = this.form.accountType = 'SIMSIM';
                }else if(this.$global.user_company_payment_engine == 'MEEZAN'){
                    this.form.paymentMethod = this.form.accountType = 'EMONEY';
                }else if(this.$global.user_company_payment_engine == 'EASY_PAISA'){
                    this.form.paymentMethod = this.form.accountType = 'EASY_PAISA_WALLET';
                }else if(this.$global.user_company_payment_engine == 'NBP_FUND'){
                    this.form.paymentMethod = this.form.accountType = 'IBFT';
                }else if(this.$global.user_company_payment_engine == 'FAYSAL'){
                    this.form.paymentMethod = this.form.accountType = 'BANK';
                }else if(this.$global.user_company_payment_engine == 'EMONEY'){
                    this.form.paymentMethod = this.form.accountType = 'IBFT';
                }
                axios.get("/api/editVendor/" + this.$route.params.id)
                .then(res => {
                    if (res.status == 200) {
                        if(res.data.wizard_cycle == 0){
                            this.$router.push('/addVendorPersonalDetail/'+this.$route.params.id);
                        }else if(res.data.wizard_cycle == 1){
                            this.$router.push('/addVendorBasicDetail/'+this.$route.params.id);
                        }else if(res.data.wizard_cycle == 2){
                            this.$router.push('/addVendorTaxDetail/'+this.$route.params.id);
                        }else if(res.data.wizard_cycle == 3){
                            this.getDefaultWallet();
                            this.getBankList();
                            this.basicDetail = 1;
                        }
                    } else {
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load data.')
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load data.');
                });
                const $selectpicker = $('document').find('.selectpicker');
                $selectpicker.selectpicker().on('changed.bs.select', () => this.$emit('changeWeek', this.options[$selectpicker.val()]));
            });
        }
    }
</script>
